package common.frontend.api

import common.frontend.api.Io.Permission.Companion.OTHERS_ADD


/* USER*/
fun Io.Permission.canUserEdit(targetCompanyOfUserId: Long, userCompanyId: Long): Boolean =
    canUser(Io.Permission.OWN_EDIT) && targetCompanyOfUserId == userCompanyId ||
        (canUser(Io.Permission.OTHERS_EDIT) && targetCompanyOfUserId != userCompanyId)

fun Io.User.canUserPermissionEdit(targetCompanyOfUserId: Long): Boolean =
    canUserPermissionEditOwnCompany(targetCompanyOfUserId) || canUserPermissionEditOthersCompany(targetCompanyOfUserId)

fun Io.User.canUserPermissionEditOwnCompany(targetCompanyOfUserId: Long): Boolean {
    val isMineCompany = targetCompanyOfUserId == company.id
    return if (isMineCompany) permission.canUserPermission(Io.Permission.OWN_EDIT)
    else permission.canUserPermission(Io.Permission.OTHERS_EDIT)
}

fun Io.User.canUserPermissionEditOthersCompany(targetCompanyOfUserId: Long): Boolean =
    permission.canUserPermission(Io.Permission.OTHERS_EDIT)
        && (permission.isServerAdmin() || targetCompanyOfUserId == company.id)

fun Io.User.canUserEdit(companyId: Long): Boolean {
    return permission.canUserEdit(companyId, company.id)
}

fun Io.User.canUserView(companyId: Long = company.id): Boolean {
    return (permission.canUser(Io.Permission.OWN_VIEW) && companyId == company.id) ||
        (permission.canUser(Io.Permission.OTHERS_VIEW) && companyId != company.id)
}

fun Io.User.canUserAdd(companyId: Long = company.id): Boolean {
    return (permission.canUser(Io.Permission.OWN_ADD) && companyId == company.id) ||
        (permission.canUser(OTHERS_ADD) && companyId != company.id)
}

fun Io.User.canUserDelete(targetCompanyId: Long): Boolean {
    return (permission.canLocation(Io.Permission.OWN_DELETE) && targetCompanyId == company.id) ||
        (permission.canLocation(Io.Permission.OTHERS_DELETE) && targetCompanyId != company.id)
}


/* COMPANY */

fun Io.User.canDeviceInfoView(companyId: Long = company.id): Boolean {
    return (permission.canDeviceInfo(Io.Permission.OWN_VIEW) && companyId == company.id) ||
        (permission.canDeviceInfo(Io.Permission.OTHERS_VIEW) && companyId != company.id)
}

fun Io.User.canDeviceInfoAdd(companyId: Long = company.id): Boolean {
    return (permission.canDeviceInfo(Io.Permission.OWN_ADD) && companyId == company.id) ||
        (permission.canDeviceInfo(OTHERS_ADD) && companyId != company.id)
}

fun Io.User.canCompanyView(companyId: Long = company.id): Boolean {
    return (permission.canCompany(Io.Permission.OWN_VIEW) && companyId == company.id) ||
        (permission.canCompany(Io.Permission.OTHERS_VIEW) && companyId != company.id)
}

fun Io.User.canCompanyEdit(companyId: Long): Boolean {
    return permission.canCompanyEdit(companyId, company.id)
}

fun Io.User.isServerAdmin(): Boolean = canCompanyAdd()
fun Io.User.isSuperAdmin(): Boolean = canServerView()

fun Io.User.isCompanyAdmin(): Boolean = canCompanyEdit(company.id)
fun Io.User.isAdCompanyPublisher(): Boolean = canLayerTopAdd(company.id)
fun Io.User.isAdServerPublisher(): Boolean = permission.canDeviceLayerTop(OTHERS_ADD) && isAdCompanyPublisher()

fun Io.User.canCompanyAdd(): Boolean = permission.canCompany(OTHERS_ADD)


fun Io.Permission.canCompanyEdit(targetId: Long, userCompanyId: Long): Boolean {
    return (canCompany(Io.Permission.OWN_EDIT) && targetId == userCompanyId) ||
        (canCompany(Io.Permission.OTHERS_EDIT) && targetId != userCompanyId)
}

fun Io.User.canCompanyDelete(targetCompanyId: Long): Boolean {
    return (permission.canCompany(Io.Permission.OTHERS_DELETE) && targetCompanyId != company.id)
}

/* LOCATION */

fun Io.User.canLocationEdit(companyId: Long): Boolean {
    return permission.canLocation(Io.Permission.OWN_EDIT) && companyId == company.id ||
        (permission.canLocation(Io.Permission.OTHERS_EDIT) && companyId != company.id)
}

fun Io.User.canLocationAdd(companyId: Long): Boolean {
    return permission.canLocation(Io.Permission.OWN_ADD) && companyId == company.id ||
        (permission.canLocation(OTHERS_ADD) && companyId != company.id)
}

fun Io.User.canLocationView(companyId: Long = company.id): Boolean {
    return (permission.canLocation(Io.Permission.OWN_VIEW) && companyId == company.id) ||
        (permission.canLocation(Io.Permission.OTHERS_VIEW) && companyId != company.id)
}

fun Io.User.canLocationDelete(targetCompanyId: Long): Boolean {
    return (permission.canLocation(Io.Permission.OWN_DELETE) && targetCompanyId == company.id) ||
        (permission.canLocation(Io.Permission.OTHERS_DELETE) && targetCompanyId != company.id)
}
/* LOCATION_EMERGENCY */

fun Io.User.canLocationEmergencyEdit(companyId: Long): Boolean {
    return permission.canLocationEmergency(Io.Permission.OWN_EDIT) && companyId == company.id ||
        (permission.canLocationEmergency(Io.Permission.OTHERS_EDIT) && companyId != company.id)
}

fun Io.User.canLocationEmergencyView(companyId: Long): Boolean {
    return permission.canLocationEmergency(Io.Permission.OWN_VIEW) && companyId == company.id ||
        (permission.canLocationEmergency(Io.Permission.OTHERS_VIEW) && companyId != company.id)
}

fun Io.User.canLocationEmergencyAdd(companyId: Long): Boolean {
    return permission.canLocationEmergency(Io.Permission.OWN_ADD) && companyId == company.id ||
        (permission.canLocationEmergency(OTHERS_ADD) && companyId != company.id)
}

/* DEVICE */

fun Io.User.canDeviceEdit(targetCompanyId: Long): Boolean {
    return (permission.canDeviceInfo(Io.Permission.OWN_EDIT) && targetCompanyId == company.id) ||
        (permission.canDeviceInfo(Io.Permission.OTHERS_EDIT) && targetCompanyId != company.id)
}

fun Io.User.canDeviceAdd(targetCompanyId: Long): Boolean {
    return (permission.canDeviceInfo(Io.Permission.OWN_ADD) && targetCompanyId == company.id) ||
        (permission.canDeviceInfo(OTHERS_ADD) && targetCompanyId != company.id)
}

fun Io.User.canDeviceDelete(targetCompanyId: Long): Boolean {
    return (permission.canDeviceInfo(Io.Permission.OWN_DELETE) && targetCompanyId == company.id) ||
        (permission.canDeviceInfo(Io.Permission.OTHERS_DELETE) && targetCompanyId != company.id)
}

fun Io.User.canDeviceView(targetCompanyId: Long): Boolean {
    return (permission.canDeviceInfo(Io.Permission.OWN_VIEW) && targetCompanyId == company.id) ||
        (permission.canDeviceInfo(Io.Permission.OTHERS_VIEW) && targetCompanyId != company.id)
}

fun Io.User.canDeviceDisplayEdit(targetCompanyId: Long): Boolean {
    return (permission.canDeviceDisplay(Io.Permission.OWN_EDIT) && targetCompanyId == company.id) ||
        (permission.canDeviceDisplay(Io.Permission.OTHERS_EDIT) && targetCompanyId != company.id)
}

/**/
fun Io.User.canLayerBottomEdit(targetCompanyId: Long): Boolean {
    return (permission.canDeviceLayerBottom(Io.Permission.OWN_EDIT) && targetCompanyId == company.id) ||
        (permission.canDeviceLayerBottom(Io.Permission.OTHERS_EDIT) && targetCompanyId != company.id)
}

fun Io.User.canLayerBottomView(targetCompanyId: Long): Boolean {
    return (permission.canDeviceLayerBottom(Io.Permission.OWN_VIEW) && targetCompanyId == company.id) ||
        (permission.canDeviceLayerBottom(Io.Permission.OTHERS_VIEW) && targetCompanyId != company.id)
}

fun Io.User.canLayerBottomAdd(targetCompanyId: Long): Boolean {
    return (permission.canDeviceLayerBottom(Io.Permission.OWN_ADD) && targetCompanyId == company.id) ||
        (permission.canDeviceLayerBottom(OTHERS_ADD) && targetCompanyId != company.id)
}

fun Io.User.canLayerBottomDelete(targetCompanyId: Long): Boolean {
    return (permission.canDeviceLayerBottom(Io.Permission.OWN_DELETE) && targetCompanyId == company.id) ||
        (permission.canDeviceLayerBottom(Io.Permission.OTHERS_DELETE) && targetCompanyId != company.id)
}

/**/
fun Io.User.canDeviceDisplayView(targetCompanyId: Long): Boolean {
    return (permission.canDeviceDisplay(Io.Permission.OWN_VIEW) && targetCompanyId == company.id) ||
        (permission.canDeviceDisplay(Io.Permission.OTHERS_VIEW) && targetCompanyId != company.id)
}

fun Io.User.canDeviceActionsView(targetCompanyId: Long): Boolean {
    return (permission.canDeviceAction(Io.Permission.OWN_VIEW) && targetCompanyId == company.id) ||
        (permission.canDeviceAction(Io.Permission.OTHERS_VIEW) && targetCompanyId != company.id)
}

/*SERVER*/
fun Io.User.canServerView(serverId: Long = server.id): Boolean {
    return (permission.canServer(Io.Permission.OWN_VIEW) && serverId == server.id_default) ||
        (permission.canServer(Io.Permission.OTHERS_VIEW) && serverId != server.id_default)
}

fun Io.User.canServerEdit(serverId: Long = server.id): Boolean {
    return (permission.canServer(Io.Permission.OWN_EDIT) && serverId == server.id_default) ||
        (permission.canServer(Io.Permission.OTHERS_EDIT) && serverId != server.id_default)
}

fun Io.User.canServerDelete(serverId: Long = server.id): Boolean {
    return (permission.canServer(Io.Permission.OTHERS_DELETE) && serverId != server.id_default)
}

fun Io.User.canServerAdd(): Boolean {
    return permission.canServer(OTHERS_ADD)
}

/*LICENSE*/
fun Io.User.canLicenseAdd(targetCompanyId: Long): Boolean {
    return (company.id == targetCompanyId && permission.canLicense(Io.Permission.OWN_ADD))
        || (company.id != targetCompanyId && permission.canLicense(OTHERS_ADD))
}

fun Io.User.canLicenseView(): Boolean {
    return canLicenseOwnView() || canLicenseOthersView()
}

fun Io.User.canLicenseOwnView(): Boolean {
    return permission.canLicense(Io.Permission.OWN_VIEW)
}

fun Io.User.canLicenseOthersView(): Boolean {
    return permission.canLicense(Io.Permission.OTHERS_VIEW)
}

fun Io.User.canLicenseEdit(targetCompanyId: Long): Boolean {
    return (company.id == targetCompanyId && permission.canLicense(Io.Permission.OWN_EDIT))
        || (company.id != targetCompanyId && permission.canLicense(Io.Permission.OTHERS_EDIT))
}

fun Io.User.canLicenseDelete(targetCompanyId: Long): Boolean {
    return (company.id == targetCompanyId && permission.canLicense(Io.Permission.OWN_DELETE))
        || (company.id != targetCompanyId && permission.canLicense(Io.Permission.OTHERS_DELETE))
}

/*HARDWARE*/
fun Io.User.canHardwareView(): Boolean {
    return permission.canHardware(Io.Permission.OWN_VIEW)
}

fun Io.User.canHardwareAdd(): Boolean {
    return permission.canHardware(Io.Permission.OWN_ADD)
}

fun Io.User.canHardwareDelete(): Boolean {
    return permission.canHardware(Io.Permission.OWN_DELETE)
}

fun Io.User.canHardwareEdit(): Boolean {
    return permission.canHardware(Io.Permission.OWN_EDIT)
}

/*RESOURCE*/
fun Io.User.canResourceView(companyId: Long): Boolean {
    return (permission.canResource(Io.Permission.OWN_VIEW) && companyId == company.id) ||
        (permission.canResource(Io.Permission.OTHERS_VIEW) && companyId != company.id)
}

fun Io.User.canResourceAdd(companyId: Long): Boolean {
    return (permission.canResource(Io.Permission.OWN_ADD) && companyId == company.id) ||
        (permission.canResource(OTHERS_ADD) && companyId != company.id)
}

fun Io.User.canResourceDelete(companyId: Long): Boolean {
    return (permission.canResource(Io.Permission.OWN_DELETE) && companyId == company.id) ||
        (permission.canResource(Io.Permission.OTHERS_DELETE) && companyId != company.id)
}

fun Io.User.canResourceEdit(companyId: Long): Boolean {
    return (permission.canResource(Io.Permission.OWN_EDIT) && companyId == company.id) ||
        (permission.canResource(Io.Permission.OTHERS_EDIT) && companyId != company.id)
}

/*CAMPAIGN*/
fun Io.User.canLayerTopView(companyId: Long = company.id): Boolean {
    return (permission.canDeviceLayerTop(Io.Permission.OWN_VIEW) && companyId == company.id) ||
        (permission.canDeviceLayerTop(Io.Permission.OTHERS_VIEW) && companyId != company.id)
}

fun Io.User.canLayerTopAdd(companyId: Long): Boolean {
    return (permission.canDeviceLayerTop(Io.Permission.OWN_ADD) && companyId == company.id) ||
        (permission.canDeviceLayerTop(OTHERS_ADD) && companyId != company.id)
}

fun Io.User.canLayerTopEdit(companyId: Long): Boolean {
    return (permission.canDeviceLayerTop(Io.Permission.OWN_EDIT) && companyId == company.id) ||
        (permission.canDeviceLayerTop(Io.Permission.OTHERS_EDIT) && companyId != company.id)
}

fun Io.User.canLayerTopDelete(companyId: Long): Boolean {
    return (permission.canDeviceLayerTop(Io.Permission.OWN_DELETE) && companyId == company.id) ||
        (permission.canDeviceLayerTop(Io.Permission.OTHERS_DELETE) && companyId != company.id)
}


/* TRANSLATION */

fun Io.User.canTranslationAdd(): Boolean {
    return permission.canTranslation(Io.Permission.OWN_ADD)
}

fun Io.User.canTranslationEdit(): Boolean {
    return permission.canTranslation(Io.Permission.OWN_EDIT)
}

fun Io.User.canTranslationView(): Boolean {
    return permission.canTranslation(Io.Permission.OWN_VIEW)
}

/* REPORT */
fun Io.User.canReportSystemView(targetCompanyId: Long): Boolean {
    return (permission.canDeviceLayerBottom(Io.Permission.OWN_EDIT) && targetCompanyId == company.id) ||
        (permission.canDeviceLayerBottom(Io.Permission.OTHERS_EDIT) && targetCompanyId != company.id)
}

fun Io.User.canReportLayerTopView(targetCompanyId: Long): Boolean {
    return (permission.canReportLayerTop(Io.Permission.OWN_VIEW) && targetCompanyId == company.id) ||
        (permission.canReportLayerTop(Io.Permission.OTHERS_VIEW) && targetCompanyId != company.id)
}
